<template>
  <v-dialog
    :value="show"
    max-width="900px"
    transition="dialog-transition"
    :persistent="persistent"
    @input="$emit('change-value', $event)"
  >
    <v-card height="563px">
      <v-layout justify-center align-center class="b-borders">
        <v-flex md12>
          <v-text-field solo 
          label="Buscar..." 
          prepend-icon="fas fa-search" 
          ref="searchFilter" flat color="black" class="transparent"
          @input="$emit('change-search', text)"
          v-model="text"></v-text-field>
        </v-flex>
        <v-flex md1 mr-2>
          <v-btn small flat block @click="deleteSearch" v-if="text.length > 0">
            BORRAR
          </v-btn>
        </v-flex>
        <v-flex md1>
          <v-btn small icon @click="$emit('change-value', false)">
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="b-borders h-50" v-if="filtersBar.length > 0">
        <v-flex md2
          v-for="(filter, i) in filtersBar"
          :key="`filter-${i}`"
          @click="filters['filter'] = filter.value"
          class="text-xs-center advanced-filter mt-3px"
          :class="{'hovered': filters['filter'] !== filter.value, 'b-borders': filters['filter'] === filter.value}">
          {{filter.name}}
        </v-flex>
      </v-layout>

      <v-card-text class="py-1">
        <v-layout row wrap>
          <v-flex :class="{'md7': customFilters.length, 'md12': !customFilters.length}" class="highlight black--text">
            {{title.toUpperCase()}} ENCONTRADOS ({{finded}})
          </v-flex>
          <v-flex v-if="customFilters.length" md5 class="highlight black--text">
            FILTRAR POR
          </v-flex>
        </v-layout>
        <v-layout row wrap fill-height>
          <v-flex :class="{'md7': customFilters.length, 'md12': !customFilters.length}" pr-3>
            <vue-perfect-scrollbar class="scrollbar">
              <v-layout row wrap v-if="text !== ''" pr-2>
                <data-table
                  :key="`data-table-${filters['filter']}`"
                  :search-on-create="searchOnCreate"
                  :url="url"
                  :search="text"
                  :filters="filters"
                  @send-total="finded = $event">
                    <template slot="content" slot-scope="props">
                      <slot name="list" :items="props.items" :filters="filters" :highlight="highlight"></slot>
                    </template>
                  </data-table>
              </v-layout>
              <v-layout justify-center align-center fill-height pb-3 v-else>
                <v-flex md12 class="text-xs-center f1-4em grey--text">
                  <v-icon class="f1-2em pr-2">fas fa-search</v-icon>
                  Inicie su busqueda...
                </v-flex>
              </v-layout>
            </vue-perfect-scrollbar>
          </v-flex>
          <v-flex v-if="customFilters.length" md5>
            <vue-perfect-scrollbar class="scrollbar">
              <v-layout row wrap mt-2>
                <v-flex md12 v-for="(filter, i) in customFilters" :key="`custom-filter-${i}`">
                  <v-select
                    :items="filter.items"
                    v-model="filters[filter.nameFilter]"
                    :item-text="filter.nameText || 'name'"
                    :item-value="filter.valueText || 'value'"
                    :label="filter.name"
                    color="black"
                    class="elevation-0 a-borders white-no-border"
                    solo
                  ></v-select>
                </v-flex>
              </v-layout>
            </vue-perfect-scrollbar>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DataTable from '@/components/global/DataTable2';
import vuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
    filtersBar: {
      type: Array,
      default: [],
    },
    customFilters: {
      type: Array,
      default: [],
    },
    title: {
      type: String,
      default: 'Busqueda',
    },
    searchOnCreate: {
      type: Boolean,
      defautl: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DataTable,
    vuePerfectScrollbar,
  },
  data() {
    return {
      text: '',
      finded: 0,
      filters: {
        filter: 'name',
      },
    };
  },
  methods: {
    highlight(word) {
      const regEx = new RegExp(this.text, 'ig');
      return word.toUpperCase().replace(regEx, `<span class='highlight'>${this.text.toUpperCase()}</span>`);
    },
    deleteSearch() {
      this.items = [];
      this.text = '';
      this.$refs.searchFilter.focus();
    },
  },
};
</script>

<style scoped>
.mt-3px {
  margin-top: 3px !important;
}

.h-50 {
  height: 50px !important;
}
.scrollbar {
  height: 400px;
}
.layout.b-borders {
  border-color: rgba(0, 0, 0, 0.1) !important;
  height: 70px;
}

.advanced-filter {
  padding-top:12px !important;
  color:#727272 !important;
  font-weight: 500 !important;
}

.advanced-filter.b-borders {
  border-color: #ff7c64 !important;
  border-width: 3px !important;
}
.highlight {
  color: #000!important;
}
.hovered:hover {
  cursor:pointer !important;
  background-color: rgba(0, 0, 0, 0.08) !important;
  transition: 0.3s ease-in !important;
}
</style>



// WEBPACK FOOTER //
// src/components/global/SearchModalV2.vue